import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { AmenityModal } from 'src/components/property/PropertyUtilitiesSetupPageV2/AmenityModal';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { BackdropLoader } from '@livable/saas-react-components';
export const SingleAmenities = observer(_ref => {
  let amenities = _ref.amenities,
    isEdit = _ref.isEdit,
    isLoading = _ref.isLoading;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.common_area_amenities')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('add_new_property_flow.common_area_amenities_hint_second')), store.addNewProperty.utilitiesSetupV2.availableCommonAreaAmenities.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('add_new_property_flow.amenities'))), amenities.length ? amenities.map(amenity => {
    var _amenity$commonAreaAm;
    return /*#__PURE__*/React.createElement(AmenityModal, {
      title: amenity.name,
      info: amenity.amenitySelectedOptionName || amenity.commonAreaAmenityOptions.length && ((_amenity$commonAreaAm = amenity.commonAreaAmenityOptions[0]) === null || _amenity$commonAreaAm === void 0 ? void 0 : _amenity$commonAreaAm.name) || '',
      selectedAmenity: amenity,
      key: amenity.id,
      multiple: false,
      editMode: isEdit
    });
  }) : ''), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(AmenityModal, null))));
});